import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PessoaAuditoriaAcessoListaComponent } from './pessoa-auditoria-acesso-lista/pessoa-auditoria-acesso-lista.component';

const routes: Routes = [
  { path: 'pessoaAuditoriaAcesso/listar', component: PessoaAuditoriaAcessoListaComponent, data: { titulo: 'Lista as Auditorias de Consulta de Pessoas' }  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PessoaAuditoriaAcessoRoutingModule { }
